import { Key } from "../../../../../../Global/Base/Utils/EventUtils";
import { Localization } from "../../../../../../OW.Remoting/Remoting/Localization";
import { Action } from "../../../../../UI.Controls/Actions/Action";
import { DropDownMenuItem } from "../../../../../UI.Controls/DropDownMenu/DropDownMenuItem";
import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { Icon } from "../../../FormUI/FormUI";

export class DropDownMenuFormProfileItem extends DropDownMenuItem {
    public isClickable: boolean = false;

    private _profileID: string;
    private _profileName: string;
    private _defaultElement: HTMLElement;
    private _selected: boolean;
    private _defaultProfile: boolean;
    private _isImplementation: boolean;
    private _canEdit: boolean;
    private _isEdited: boolean = false;

    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    public set profileName(value: string) {
        this._updateCaption(value);
    }

    public get profileName(): string {
        return this._profileName;
    }

    public get profileID(): string {
        return this._profileID;
    }

    public set profileID(value: string) {
        this._profileID = value;
    }

    public set selected(value: boolean) {
        this._selected = value;
        if (value) {
            this.icon = Icon[Icon.selectFromLov];
        } else {
            this.icon = Icon[Icon.none];
        }
    }

    public get selected(): boolean {
        return this._selected;
    }

    public set defaultProfile(value: boolean) {
        this._defaultProfile = value;
        this._defaultElement.hidden = !value;
    }

    public get defaultProfile(): boolean {
        return this._defaultProfile;
    }

    public set isImplementation(value: boolean) {
        this._isImplementation = value;
    }

    public get isImplementation(): boolean {
        return this._isImplementation;
    }

    public get isEdited(): boolean {
        return this._isEdited;
    }

    public set isEdited(value: boolean) {
        this._isEdited = value;
        this._updateCaption(this._profileName);
    }

    protected override _constructor(profileID: string = null): void {
        super._constructor();

        this.visible = true;
        this._profileID = profileID;
        this._selected = false;
        this._defaultProfile = false;
    }

    public static createDropDownMenuFormProfileItem(icon: string, fnc: () => Promise<void>, id: number | null = null, name: string = "", locKey: string = "", defaultProfile: boolean = false, isImplementation: boolean = false, canEdit: boolean, selected: boolean = false, enabled: boolean = false, priority: number = 15): DropDownMenuFormProfileItem {
        const dropDownMenuItem = new DropDownMenuFormProfileItem();
        const action = new Action(fnc);

        //action.LocKey = name; //locKey;

        dropDownMenuItem.profileID = id?.toString();
        dropDownMenuItem.profileName = name;
        dropDownMenuItem.locKey = locKey;

        dropDownMenuItem.action = action;
        action.enabled = enabled;

        dropDownMenuItem.icon = icon;
        dropDownMenuItem.priority = priority;

        dropDownMenuItem.defaultProfile = defaultProfile;
        dropDownMenuItem._isImplementation = isImplementation;
        dropDownMenuItem._canEdit = canEdit;
        dropDownMenuItem.selected = selected;

        return dropDownMenuItem;
    }

    private async _updateCaption(value: string): Promise<void> {
        if (value) {
            let caption: string;
            caption = value;
            this._profileName = caption;

            if (this._isImplementation && this._canEdit) {
                const impText = await Localization.getTextPromise("GUI-740260"); // [IMP]
                caption += impText;
            }

            if (this._isEdited) {
                const item = await Localization.getTextPromise("GUI-624409"); // Upraveno; Obsah závorky upraveného zobrazení (profilu)
                caption += ` (${item})`;
            }

            this.setCaption(caption, this.locKey);
            this.setLocalizedCaption(this.locKey);
        }
    }

    public override focus(): void {
        // Prázdná metoda
    }

    protected override _createElement(): void {
        super._createElement();

        this.classList.add("DropDownMenuItem", "form-profile-item");

        this._defaultElement = document.createElement("div");
        this._defaultElement.classList.add("sub-text");
        Localization.addLocTxtData(this._defaultElement, "GUI-454139", undefined, undefined, true); // Výchozí
        this._textElement.appendChild(this._defaultElement);
    }

    protected override _setListener(): void {
        const clickHandler = async (e: MouseEvent | KeyboardEvent) => {
            e.stopImmediatePropagation();

            if (!this.classList.contains("Disabled")) {
                if (typeof this.action.execute === "function") {
                    await (this.action as Action).execute();
                }
                if (!this.noCloseAfterSelect) {
                    this.parent.closeAll();
                }
            }
        };
        this.registerEventListener("click", (e: MouseEvent) => {
            if (e.button === 0) {
                clickHandler(e);
            }
        });
        this.registerEventListener("keyup", (e: KeyboardEvent) => {
            if (e.key === Key.Enter) {
                clickHandler(e);
            }
        });
    }

    public override dispose(): void {
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownMenuFormProfileItem", DropDownMenuFormProfileItem);
